module.exports = __webpack_public_path__ + "ae2925aef458d3b724f819011319ea79.svg";